import { render, staticRenderFns } from "./gestionCodigosLista.vue?vue&type=template&id=93c23f78&scoped=true"
import script from "./gestionCodigosLista.vue?vue&type=script&lang=js"
export * from "./gestionCodigosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c23f78",
  null
  
)

export default component.exports